// extracted by mini-css-extract-plugin
export default {"date":"Date_date__pQqeS","date_text":"Date_date_text__9LCgg"};